export default __webpack_public_path__ + "static/media/frog-look-to-left.0ced4f0f.webp";